import { getEnv } from "@/env";

export const VUE_APP_NODE_ENV = getEnv("VUE_APP_NODE_ENV");
